import { render, staticRenderFns } from "./GroupChart.vue?vue&type=template&id=0bd1bd97&scoped=true"
import script from "./GroupChart.vue?vue&type=script&lang=js"
export * from "./GroupChart.vue?vue&type=script&lang=js"
import style0 from "./GroupChart.vue?vue&type=style&index=0&id=0bd1bd97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1bd97",
  null
  
)

/* custom blocks */
import block0 from "./GroupChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports